// extracted by mini-css-extract-plugin
export var createdDate = "_o5-1";
export var divider = "_o5-2";
export var headerDivider = "_o5-3";
export var messagesCard = "_o5-0";
export var messagesContainer = "_o5-7";
export var messagesContainerWrapper = "_o5-4";
export var pointerCapturingButtonBoxes = "_o5-a";
export var showLeftPanelButton = "_o5-9";
export var showMoreButton = "_o5-c";
export var showMoreButtonContainer = "_o5-b";
export var summaryTitle = "_o5-6";
export var systemMessageCardWrapper = "_o5-d";
export var topButtons = "_o5-8";
export var withPadding = "_o5-5";